import React from 'react'
import { Offcanvas } from 'react-bootstrap'

export const MobileSideBarContainer = ({ show, onShow, header, children }) => {
  return (
    <div className="d-block d-lg-none">
      <Offcanvas show={show} onHide={onShow}>
        <Offcanvas.Header closeButton className="border-bottom bg-primary-subtle ">
          <Offcanvas.Title>{header}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>{children}</Offcanvas.Body>
      </Offcanvas>
    </div>
  )
}
